/* Higher Fitting — UI behaviors (qty steppers, mobile nav, PDP gallery) */
(function () {
  'use strict';

  document.addEventListener('click', function (e) {
    /* qty steppers */
    var step = e.target.closest('[data-hf-step]');
    if (step) {
      var input = step.parentElement.querySelector('input');
      var v = parseInt(input.value, 10) || 1;
      input.value = Math.max(parseInt(input.min, 10) || 1, v + parseInt(step.dataset.hfStep, 10));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    /* mobile nav */
    var burger = e.target.closest('[data-hf-burger]');
    if (burger) {
      var nav = document.getElementById('hf-nav');
      if (nav) nav.classList.toggle('is-open');
      return;
    }
    var sub = e.target.closest('[data-hf-subtoggle]');
    if (sub && window.matchMedia('(max-width: 990px)').matches) {
      e.preventDefault();
      sub.closest('.hf-nav__item').classList.toggle('is-open');
      return;
    }

    /* PDP thumbs */
    var thumb = e.target.closest('[data-hf-thumb]');
    if (thumb) {
      var main = document.getElementById('hf-pdp-main-img');
      if (main) { main.src = thumb.dataset.full; main.srcset = ''; }
      thumb.closest('.hf-pdp__thumbs').querySelectorAll('button').forEach(function (b) { b.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      return;
    }
  });

  /* contact form success scroll */
  if (/contact_posted=true/.test(window.location.search)) {
    document.addEventListener('DOMContentLoaded', function () {
      var ok = document.getElementById('hf-form-success');
      if (ok) ok.scrollIntoView({ block: 'center' });
    });
  }
})();
